export const capitalizeEachWord = (sentence: string | null | undefined) => {
  if (!sentence) {
    return "";
  }
  const trimmedSentence = sentence.trim();
  const capitalizeNonPrepositionWord = (word: string, index: number) => {
    if (index !== 0 && /^(?:of|on|at|in|to|by|against|with(?:in)?)$/i.test(word)) {
      return word.toLowerCase();
    }
    return word.charAt(0).toUpperCase() + word.substring(1).toLowerCase();
  };
  return trimmedSentence.split(/\s+/).map(capitalizeNonPrepositionWord).join(" ");
};
